// extracted by mini-css-extract-plugin
module.exports = {"statsheight":"5.625rem"};